export default {
    wrapStepper: { py: 0, px: 4 },
    stepper: {
        marginTop: 2,
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridGap: "10px",
        maxHeight: "22vh",
        overflowY: "scroll",
        "& .MuiStepLabel-labelContainer .MuiStepLabel-label": {
            fontSize: "0.7em",
            textTransform: "capitalize",
        },
    },
    hideBorder: {
        "& .MuiStepConnector-alternativeLabel": {
            display: "none",
        },
    },
    wrapNotes: { paddingTop: 4 },
    loadingBtn: { width: "100%", borderRadius: 3 },
    actionGrid: { my: 0, mx: 2 },
    notes: {
        paddingTop: 2,
    },
    completed: { color: "text.primary" },
};
